import { api } from './api'

export const paymentsService = {
  /**
   * Инициализация платежа
   * @param {number} orderId - ID заказа
   * @param {number} amount - Сумма
   * @param {string} returnUrl - URL возврата
   * @param {string} customerEmail - Email покупателя
   * @param {string} paymentMethod - Метод оплаты: 'sbp' или 'card'
   */
  initPayment: async (orderId, amount, returnUrl, customerEmail, paymentMethod = 'sbp') => {
    const response = await api.post('/payments/payments/init/', {
      order_id: orderId,
      amount: amount,
      return_url: returnUrl,
      customer_email: customerEmail,
      payment_method: paymentMethod
    })
    return response.data
  },

  /**
   * Проверка статуса платежа по payment_id
   */
  checkStatus: async (paymentId) => {
    const response = await api.get('/payments/payments/status/', {
      params: { payment_id: paymentId }
    })
    return response.data
  },

  /**
   * Проверка статуса платежа по order_id (для polling после оплаты)
   */
  checkStatusByOrder: async (orderId) => {
    const response = await api.get('/payments/payments/check/', {
      params: { order_id: orderId }
    })
    return response.data
  },

  /**
   * Доступные методы оплаты
   */
  getAvailableMethods: () => {
    return [
      {
        id: 'sbp',
        name: 'СБП',
        description: 'Система быстрых платежей',
        icon: '🏦',
        recommended: true
      },
      {
        id: 'card',
        name: 'Банковская карта',
        description: 'Visa, Mastercard, МИР',
        icon: '💳',
        recommended: false
      }
    ]
  }
}
